module.exports = __webpack_public_path__ + "img/slide13.88b6da98.jpg";